import { getRandomArrayElement } from '@sketchnote/shared-components';
import { TablePlusColorsKeys } from '@sketchnote/table';
import { createPluginFactory, ELEMENT_TABLE, KEY_DESERIALIZE_HTML } from '@udecode/plate';
import { Node } from 'slate';
import { v4 as uuid } from 'uuid';
export const ELEMENT_TABLE_PLUS = 'table_plus';

export const createTablePlusPlugin = createPluginFactory({
  key: ELEMENT_TABLE_PLUS,
  isElement: true,
  isVoid: true,
  inject: {
    pluginsByKey: {
      [KEY_DESERIALIZE_HTML]: {
        editor: {
          insertData: {
            format: 'text/html',
            transformFragment: (fragment) => {
              fragment.map((obj, index) => {
                if (obj.type === ELEMENT_TABLE) {
                  fragment[index] = changeTableToTablePlus(obj);
                }
              });
              return fragment;
            },
          },
        },
      },
    },
  },
});

function changeTableToTablePlus(data) {
  const arr: any = {
    type: ELEMENT_TABLE_PLUS,
    children: [{ text: '' }],
    column: [],
    row: [],
  };
  const maxDataLength = Math.max(...data.children.map((obj) => obj.children.length));

  arr.column = createColumns(maxDataLength);
  arr.row = createRow(data.children.length);
  let isHeadingAdded = false;
  data.children.map((obj, rowIndex) => {
    obj.children.map((item, colIndex) => {
      if (item.type === 'th') {
        arr.column[colIndex].name = Node.string(item);
        isHeadingAdded = true;
      } else if (item.type === 'td') {
        const rowIndexWithoutHeading = isHeadingAdded ? rowIndex - 1 : rowIndex;
        arr.row[rowIndexWithoutHeading] = {
          ...arr.row[rowIndexWithoutHeading],
          [arr.column[colIndex].key]: {
            text: { content: [{ children: [{ text: Node.string(item) }] }] },
          },
        };
      }
    });
  });
  return arr;
}

function createRow(num: number) {
  return Array(num)
    .fill(null)
    .map(() => ({
      id: uuid(),
    }));
}

function createColumns(num: number) {
  return Array(num)
    .fill(null)
    .map(() => ({
      key: uuid(),
      type: 'text',
      name: 'Untitled',
      color: getRandomArrayElement(TablePlusColorsKeys),
      width: 300,
    }));
}
